export default "__VITE_ASSET__CKy4_yRd__"